// TeamData.js

const teamData = [
  {
    name: 'Gattu Durga Bhavani',
    rollNumber: '20VV1A1216',
    year: '2023-2024',
    role: 'Team Member',
    linkedin: '',
    github: '',
    instagram: '',
    email: '',
    website: '',
  },
  {
    name: 'Malla Naga Venkata Prasanth Naidu',
    rollNumber: '20VV1A1233',
    year: '2023-2024',
    role: 'Team Member',
    linkedin: '',
    github: '',
    instagram: '',
    email: '',
    website: '',
  },
  {
    name: 'Nulu Prameela',
    rollNumber: '20VV1A1243',
    year: '2023-2024',
    role: 'Team Member',
    linkedin: '',
    github: '',
    instagram: '',
    email: '',
    website: '',
  },
  {
    name: 'Robba Sangeetha',
    rollNumber: '20VV1A1255',
    year: '2023-2024',
    role: 'Team Member',
    linkedin: '',
    github: '',
    instagram: '',
    email: '',
    website: '',
  },
];

export default teamData;

